<div class="panel-body" style="height: 100%;">
    <div x-gauge="" x-value="measurement" x-config="config"></div>
</div>


